import { Injectable } from '@angular/core';
import { SynchronizationsService } from '@proxy/services';
import { firstValueFrom } from 'rxjs';
import { SyncConsts } from '../../AppConsts';
import { LocalDb } from '../local-db';
import { LocalDbConsts } from '../local-db-consts';
import { TeamSync } from '../objects/team-sync';

@Injectable({ providedIn: 'root' })
export class TeamRepository {
  constructor(
    private readonly _db: LocalDb,
    private readonly _syncService: SynchronizationsService
  ) {}

  async refreshTeams(): Promise<void> {
    const table = this._db.teams;

    let skip = 0;
    let total = 0;

    let teams: TeamSync[] = [];

    do {
      const result = await firstValueFrom(
        this._syncService.getTeams({
          skipCount: skip,
          maxResultCount: SyncConsts.PageSize,
        })
      );

      total = result.pagedResult.totalCount;

      teams = teams.concat(
        result.pagedResult.items.map(dto => ({
          id: dto.id,
          name: dto.name ?? '',
          activityId: dto.activityId,
        }))
      );

      skip += SyncConsts.PageSize;
    } while (skip < total);

    await this._db.transaction(LocalDbConsts.localDbReadWriteTransaction, table, async () => {
      await table.clear();
      await table.bulkAdd(teams);
    });
  }

  async getAll(): Promise<TeamSync[]> {
    return await this._db.teams.toArray();
  }

  async getByActivityId(activityId: number): Promise<TeamSync[]> {
    return this._db.teams.where('activityId').equals(activityId).toArray();
  }

  getById(id: number): Promise<TeamSync> {
    return this._db.teams.get(id);
  }
}
